import IDENTITY_TYPE_OPTS, { IDENTITY_TYPE_PRESET } from '../constants/defaultIdentityTypeOpts';
import { isCountryVietnam } from '../constants/countries';
import { isForeignCompany } from './companies';
import { isNumeric } from './numbers/isNumber';

export const getIdentityTypeOpts = (auth, identityPresets) => {
  const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
  let identityTypeOpts = IDENTITY_TYPE_OPTS;
  if (isVietnam) {
    const cccdTypeOpt = identityTypeOpts.find(o => o.value === 1);
    if (cccdTypeOpt) {
      cccdTypeOpt.text = 'CCCD';
    }
    // CPI-976: Vietnam's identity types are CCCD, Passport and Enterprise Registration Certificate
    // (value 4, relabelled). Mapped into a new object - the constant is shared.
    identityTypeOpts = identityTypeOpts
      .filter(o => o.value !== 3)
      .map(o => (o.value === 4 ? { ...o, text: 'Enterprise Registration Certificate' } : o));
  } else if (auth && isForeignCompany(auth.company)) {
    // remove NRIC & Military/Police identities
    identityTypeOpts = identityTypeOpts.filter(o => o.value !== 1 && o.value !== 3);
    // check for new identity presets
    if (identityPresets && identityPresets.length > 0) {
      identityTypeOpts = [...identityTypeOpts, ...identityPresets.map(i => ({ text: i.label, value: i.id, 'data-regex': i.regex }))];
    }
  }

  return identityTypeOpts;
};

// identityTypeID to submit for the selected ID type. A preset option's value is the preset id
// and a saved preset customer carries 6, so 6 is sent only while identityPresetID is a known
// preset. Anything else that is not a real type comes back null so the "Please select Identity
// Type" check fires, instead of being saved as 6 with no preset, which the BOT cannot map
// (MS-6661).
export const getSubmitIdentityTypeID = (identityType, identityPresetID, identityPresets) => {
  if (isNumeric(identityType) && Number(identityType) !== IDENTITY_TYPE_PRESET) {
    return identityType;
  }
  const selectedPresetID = isNumeric(identityType) ? identityPresetID : identityType;
  const isPreset = !!identityPresetID && selectedPresetID === identityPresetID &&
    (identityPresets || []).some(p => p.id === identityPresetID);
  return isPreset ? IDENTITY_TYPE_PRESET : null;
};



// WEBPACK FOOTER //
// ./src/utils/identityTypes.js